var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"vm.sideTab.rooms = !vm.sideTab.rooms\">Close</md-button></div><div layout=\"row\"><div><h3>Add Venue</h3><a href=\"\" ng-click=\"vm.closeSideTab()\">Close</a><lookups tm-data-source=\"Venue\" limit-to-list=\"limit-to-list\" doc-list=\"vm.docSvc.doc.venue\" list=\"root\" doc-service-add-method=\"tmContractDocSvc.addVenue\"><div style=\"border: solid black 1px; background-color: white\" class=\"itemCard\"><a href=\"\" ng-click=\"dCtrl.addItem(item)\"> <span class=\"glyphicon glyphicon-circle-arrow-left\"> </span></a><span>&nbsp; {{item.name}}</span></div></lookups></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/events/contracts/tabs/addVenue.jade
// module id = 277
// module chunks = 0